export const URL = 'https://tictactoe-backend-utka.onrender.com/'
export const WSURL = 'wss://tictactoe-backend-utka.onrender.com/ws/sc/'
// export const URL = 'http://127.0.0.1:8000/'
// export const WSURL = 'ws://127.0.0.1:8000/ws/sc/'